import { useEffect } from "react";

// Lightweight per-page SEO: updates <title>, meta description, and OpenGraph
// tags without any extra dependency. Called from every page component.
//
// Usage:
//   <SEO
//     title="Projects"
//     description="Long-term personal projects by Alice Lisi."
//     image="https://..."
//     path="/projects"
//   />
const SITE = "Alice Lisi";
const DEFAULT_DESC =
  "Alice Lisi is a Milano-based photographer working between long-term personal projects and commissioned editorial, portrait and fashion imagery.";
const DEFAULT_IMAGE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_creator-store-78/artifacts/qzblbkoh_F1430004.webp";

// Resolve the site's base URL at runtime so the same code works in preview,
// staging and production without hardcoding the domain.
const getBaseUrl = () =>
  (typeof window !== "undefined" && window.location?.origin) || "";

const setMeta = (attr, key, value) => {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const SEO = ({ title, description, image, path }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — Photographer, Milano`;
    const desc = description || DEFAULT_DESC;
    const img = image || DEFAULT_IMAGE;
    const url = `${getBaseUrl()}${path || (typeof window !== "undefined" ? window.location.pathname : "/")}`;

    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:image", img);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);
    setCanonical(url);
  }, [title, description, image, path]);
  return null;
};

export default SEO;
